import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-stock-trans-menu',
  templateUrl: './stock-trans-menu.component.html',
  styleUrls: ['./stock-trans-menu.component.css']
})
export class StockTransMenuComponent implements OnInit {
    stockTransKeyno;

    public requisitionNoButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'requisition', gotoParms: () => this.menu!.requisition_no ?? '' }
    ];

    public orderOrderNoButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'orderhead', gotoParms: () => this.menu!.order_internal_no ?? '' }
    ];

    public purchOrderNoButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'purchhead', gotoParms: () => this.menu!.purch_internal_no ?? '' }
    ];

    public menu?: Menu;

    public itemsListAllocations: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockTransKeyno = this.stateService.getStateParams()['stocktrans_keyno'];
    }

    private async loadMenu() {
        if (!!this.stockTransKeyno) {
            this.menu = (await this.datatask.Post(1873, { stocktrans_keyno: this.stockTransKeyno }))[0];
        }
    }

    private async loadAllocations() {
        if (!this.menu) return;

        return this.itemsListAllocations = await this.datatask.Post(1874, { stocktrans_keyno: this.menu.stocktrans_keyno });
    }

    private async init() {
        await this.loadMenu();
        this.loadAllocations();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    stocktrans_keyno: string;
    stock_keyno: string;
    stockplace_name: string;
    prod_id: string;
    prod_name: string;
    requisition_no: string;
    order_internal_no: string;
    order_order_no: string;
    purch_internal_no: string;
    purch_order_no: string;
    outgoing: string;
    incoming: string;
    expected_transdate: string;
}
